import { gql } from 'graphql-tag';
import { pageInfoFragment } from 'src/app/shared/graphql/fragments/page-info-fragment.graphql';
import { type ClientSearchWorkersQuery } from 'src/app/shared/graphql/worker-search/client-search-workers-query.graphql.autogenerated';

export type ClientSearchWorkersQueryResult = ClientSearchWorkersQuery;
export type ClientSearchWorkersQueryResultNodes = ClientSearchWorkersQueryResult['clientSearchWorkers']['nodes'];

export const ClientSearchWorkersDocument = gql`
  query clientSearchWorkers($after: String, $filters: WorkerSearchFilterAttribute, $first: Int) {
    clientSearchWorkers(after: $after, filters: $filters, first: $first) {
      nodes {
        id
        about
        normalizedType
        combinedFeedback
        deliveredHourGroup
        distanceAway
        loyaltyName
        ratings {
          id
        }
        clientFields {
          shortlisted
        }
        user {
          id
          permalink
          truncatedName
          firstName
          avatar {
            big
          }
        }
      }
      totalCount
      pageInfo {
        ...PageInfo
      }
      pageNumber
    }
  }
  ${pageInfoFragment}
`;
